
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/tracking-and-status-updates",
      function () {
        return require("private-next-pages/ai/tracking-and-status-updates.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/tracking-and-status-updates"])
      });
    }
  